import createReducer from '../../../../../common/utils/createReducer.js';
import { alerts } from '../actionTypes/alerts.js';

const initialState = {
  alerts_summary_data: {},
  isFetchingAlertsData: false,
  alertsDataFetchingError: false,
  alerts_summary_data_property: {},
  isFetchingAlertsDataProperty: false,
  alertsDataPropertyFetchingError: false,
  alerts_config: {},
  isFetchingAlertsConfig: false,
  alertsConfigError: false,
  isClosingAlert: false,
  closeAlertError: false,
  alert_response: null
};

const reducer = {
  [alerts.START_FETCHING_ALERT_SUMMARY_DATA]: state => {
    return {
      ...state,
      isFetchingAlertsData: true,
      alertsDataFetchingError: false
    };
  },

  [alerts.SUCCESS_FETCHING_ALERT_SUMMARY_DATA]: (state, action) => {
    return {
      ...state,
      isFetchingAlertsData: false,
      alerts_summary_data: action.payload.alerts_summary_data
    };
  },

  [alerts.FAILURE_FETCHING_ALERT_SUMMARY_DATA]: state => {
    return {
      ...state,
      isFetchingAlertsData: false,
      alertsDataFetchingError: true
    };
  },
  [alerts.CLEAR_ALERT_SUMMARY_DATA]: state => {
    return {
      ...state,
      isFetchingAlertsData: false,
      alertsDataFetchingError: true,
      alerts_summary_data: {}
    };
  },
  [alerts.START_FETCHING_ALERT_SUMMARY_DATA_PROPERTY]: state => {
    return {
      ...state,
      isFetchingAlertsDataProperty: true,
      alertsDataPropertyFetchingError: false
    };
  },

  [alerts.SUCCESS_FETCHING_ALERT_SUMMARY_DATA_PROPERTY]: (state, action) => {
    return {
      ...state,
      isFetchingAlertsDataProperty: false,
      alerts_summary_data_property: action.payload.alerts_summary_data_property
    };
  },

  [alerts.FAILURE_FETCHING_ALERT_SUMMARY_DATA_PROPERTY]: state => {
    return {
      ...state,
      isFetchingAlertsDataProperty: false,
      alertsDataPropertyFetchingError: true
    };
  },
  [alerts.CLEAR_ALERT_SUMMARY_DATA_PROPERTY]: state => {
    return {
      ...state,
      isFetchingAlertsDataProperty: false,
      alertsDataPropertyFetchingError: true,
      alerts_summary_data_property: {}
    };
  },
  [alerts.START_FETCHING_ALERTS_CONFIG]: state => {
    return {
      ...state,
      isFetchingAlertsConfig: true,
      alertsConfigError: false
    };
  },

  [alerts.SUCCESS_FETCHING_ALERTS_CONFIG]: (state, action) => {
    return {
      ...state,
      isFetchingAlertsConfig: false,
      alerts_config: action.payload.alerts_config
    };
  },

  [alerts.FAILURE_FETCHING_ALERTS_CONFIG]: state => {
    return {
      ...state,
      isFetchingAlertsConfig: false,
      alertsConfigError: true
    };
  },
  [alerts.CLEAR_ALERTS_CONFIG]: state => {
    return {
      ...state,
      isFetchingAlertsConfig: false,
      alerts_config: {}
    };
  },
   [alerts.START_UPDATE_ALERT]: state => {
    return {
      ...state,
      isClosingAlert: true,
      closeAlertError: false
    };
  },
   [alerts.SUCCESS_UPDATE_ALERT]: (state, action) => {
      return {
        ...state,
        isClosingAlert: false,
        closeAlertError: false,
        alert_response: action.payload.alert_response
      };
    },
  
    [alerts.FAILURE_UPDATE_ALERT]: (state, action) => {
      return {
        ...state,
        isClosingAlert: false,
        closeAlertError: true
      };
    }
};

export default createReducer(initialState, reducer);
